<template>
<div class="dropdown">
	<div class="select" @click="showMenu = !showMenu">
		<grid>
			<grid-item size="31/40" class="title">
				{{ label }}
			</grid-item>
			<grid-item size="9/40">
				<i class="icon-down-open"></i>
			</grid-item>
		</grid>
	</div>
	<ul v-if="showMenu" v-click-outside="hideList">
		<li v-for="(item, index) in itemList" :key="index">
			<custom-checkbox
				:value="selectedItems[index]"
				@input="updateResponse(index, ...arguments)"
				:label="item.name"
				:disabled="item.disabled"
			/>
		</li>
	</ul>
</div>
</template>

<script>
import CustomCheckbox from './CustomCheckbox'

export default {
	components: {
		CustomCheckbox
	},
	props: {
		label: {
			type: String
		},
		itemList: {
			type: Array
		},
		value: {
			type: Array
		},
		itemValue: {
			type: String,
			default: 'value'
		}
	},
	data: () => ({
		showMenu: false
	}),
	computed: {
		selectedItems() {
			return this.itemList.map(item => {
				return this.value.some(selectedItem => selectedItem === item[this.itemValue])
			})
		}
	},
	methods: {
		hideList() {
			this.showMenu = false
		},
		updateResponse(index, event) {
			let responses = this.selectedItems
			if(index == 0) {
				responses = responses.map((item, index) => {
					if(this.itemList[index].disabled == false) {
						item = true
					}
					return item
				})
			} else {
				this.$set(responses, index, event.target.checked)
				if(!event.target.checked) {
					this.$set(responses, 0, false)
				}
			}
			responses = responses.map((item, index) => {
				return item == true ? this.itemList[index][this.itemValue] : null
			}).filter(item => {
				return item != null
			})
			this.$emit('input', responses)
		}
	}
}
</script>

<style lang="scss">
.dropdown {
	margin-bottom: 7px;

	.select {
		background-color: rgba(20, 26, 33, 0.8);
		color: #fff;
		border: none;
		font-weight: 700;
		padding: 11px 15px 10px;
		margin: 0;
		line-height: 24px;
		border-radius: 0;
		user-select: none;
		cursor: pointer;

		&:hover {
			background: #293747;
		}

		.title {
			font-size: 13px;
			line-height: 24px;
			text-align: left;
			padding-left: 18px !important;
			font-weight: 500;
		}

		i {
			font-size: 14px;
			border-left: 1px solid #808080;
			padding-left: 12px;
			line-height: 25px;
			display: inline-block;
			color: #808080;
		}
	}

	ul {
		list-style: none;
		padding: 0px;
		margin: 0;
		background-color: #141921;
		position: absolute;
		width: 256px;
		z-index: 2;
		height: 230px;
		overflow-y: scroll;

		li {
			color: #358fb9;
			text-align: left;
			font-size: 12px;
			cursor: pointer;
			padding: 10px 18px;
			border-top: 1px solid #000;

			.empty-item {
				color: #848484;
			}
		}
	}

	ul::-webkit-scrollbar {
		width: 2px;
	}
	ul::-webkit-scrollbar-thumb {
		border: 4px solid rgba(0, 0, 0, 0);
		background-clip: padding-box;
		background-color: #4ba98b;
	}

	.checkbox {
		margin-bottom: 0px;

		label {
			padding-left: 22px;
		}
		.input-helper:before {
			border: 1px solid #a4a5a5;
		}
		.input-helper:before {
			border-radius: 0px;
		}
	}
}
</style>
